import React from 'react'

import ModalFormBuilder from 'Skelet/src/components/ModalFormBuilder.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <ModalFormBuilder
      config = {config}
      shouldShow = {this.props.shouldShow}
      close = {this.props.close}
      fields = {[{type:"textarea", dbcol:"name", placeholder:"Naam", maxLength:"256"},
        {type:"labels", dbcol:"labels"}]}
      required_fields = {[{dbcol:"name", name:"Naam"}]}
      validate_fields = {[{dbcol:"name", name:"Naam"}]}
      label_list = {this.props.label_list}
      api_method = "POST"
      api_endpoint = "/pipeline-create"
      api_block = "pipeline_create"
      api_block_clear = "pipeline_list"
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/ModalCreatePipeline.js